import { useQuery } from '../../services/NetworkManager';
import { NetworkManager } from '../../services';

export function getClientPayouts({ queryKey }) {
  const [_, pageNo, pageSize, orderBy, order, search, filters] = queryKey;
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.clientPayouts,
    data: {
      currentPage: pageNo,
      pageSize,
      sortBy: orderBy,
      sortDir: order.toUpperCase(),
      searchPhrase: search,
      filters,
    },
  });
}

export function useClientPayouts({ payload }) {
  const { pageNo, pageSize, orderBy, order, search, filters } = payload;
  const { data, isLoading, isError, error, refetch } = useQuery(
    ['clientPayouts', pageNo, pageSize, orderBy, order, search, filters],
    ({ queryKey }) => getClientPayouts({ queryKey }),
  );
  return { data, isLoading, isError, error, refetch };
}
